import styled from 'styled-components';

export const PushLeadWrapper = styled.div`
    padding: 24px;
    .custom-form-card {
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
        border: 1px solid #e8e8e8;
        margin-bottom: 24px;
        background: #ffffff;
    }

    .custom-form-card .ant-card-head {
        border-bottom: none;
        padding: 16px 24px 0;
    }

    .custom-form-card .ant-card-body {
        padding: 12px 24px 24px;
    }

    .custom-card-header {
        display: flex;
        align-items: center;
        width: 100%;
    }

    .custom-card-header span {
        font-weight: bold;
        color: #175aa0;
        font-size: 15px;
        white-space: nowrap;
    }

    .custom-card-header::after {
        content: '';
        flex: 1;
        height: 1px;
        background: #ff7a00;
        margin-left: 12px;
    }

    .lead-preview-ticket {
        background: #ffffff;
        border-radius: 12px;
        box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
        border: 1px solid #e8e8e8;
        overflow: hidden;
    }

    .ticket-header {
        padding: 16px 20px;
        color: #ffffff;
        text-align: center;
    }

    .ticket-body {
        padding: 20px;
    }

    .ticket-divider {
        border-top: 1px dashed #e8e8e8;
        margin: 16px 0;
    }
`;
